module.exports = __webpack_public_path__ + "img/logo.a9910e3a.png";